// https://stackoverflow.com/questions/53464595/how-to-use-componentwillmount-in-react-hooks

import { useRef } from 'react';

const useComponentWillMount = (func) => {
    const willMount = useRef(true);

    if (willMount.current) {
        func();
    }

    willMount.current = false;
};

export default useComponentWillMount;
